import React from 'react';
import { TeamList } from './teamList.smart';
import { GlobalQueryParams } from '../../../state/queryParams/queryParams.interface';
import { TeamsPageQuery } from './listTeams.queryParams.interface';
import { useQuerySync } from '../../../state/queryParams/useQuerySync';
import { ListTeamsQueryParamService } from './listTeams.queryParam.service';
import { di } from '../../../state/inversify.config';

export function ListTeamsPage() {
  const teamsPageQueryService = di.get<ListTeamsQueryParamService>(
    ListTeamsQueryParamService,
  );
  useQuerySync<TeamsPageQuery & GlobalQueryParams>(teamsPageQueryService);

  return <TeamList size="large" />;
}
